import { Box, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React, { useContext, useMemo } from 'react'
import { ThemeContext } from "../../context/ThemeContext";
import { TableVirtuoso } from 'react-virtuoso'
import { useSelector } from 'react-redux';
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';

const WatchlistTable = ({ columns = [], data = [], loading, handleRowClick, onRowDoubleClick, cellStyleMapper = {}, onRowRightClick, activeRowId, onHeaderClick, watchlistHeight = 100, handleShowAllSymbols }) => {
    // const symbols = useSymbolPrices();
    const { darkMode } = useContext(ThemeContext);
    const { symbols } = useSelector(state => state?.watchlist)
    const { userDetail } = useSelector(state => state.user);
    const { t } = useTranslation()
    const id = userDetail?.id;
    const isOneClick = useSelector(state => state.watchlist?.isOneclick)
    const storedHiddenSymbols = JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || [];
    const filteredSymbols = useMemo(() => {
        return Object.values(symbols).filter(symbol =>
            symbol.isVisible && symbol.isUsed &&
            !storedHiddenSymbols.includes(symbol.id)
        );
    }, [symbols, storedHiddenSymbols]);

    const VirtuosoTableComponents = {
        Table: (props) => (
            <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
        ),
        TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
        TableRow,
        TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
    };

    const fixedHeaderContent = () => (<TableRow >
        {columns.map((col, index) => (
            <TableCell onContextMenu={onHeaderClick} key={index} style={{ width: col?.width }} sx={{ fontWeight: "bold", p: 1, backgroundColor: darkMode ? "var(--background-color)" : 'var(--white)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {col.title}
            </TableCell>
        ))}
    </TableRow>)
    const Row = useMemo(() => (index, row) => {
        return (
            <React.Fragment >
                {columns.map((col, colIndex) => {
                    const alignStyle = {};
                    return (
                        <TableCell sx={{ border: 'none', fontSize: "0.875rem", ...alignStyle, }}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleRowClick && handleRowClick(row); }}
                            onDoubleClick={() => { onRowDoubleClick && onRowDoubleClick(row); }}
                            onContextMenu={(e) => { e.preventDefault(); e.stopPropagation(); onRowRightClick && onRowRightClick(e, row); }}
                            key={colIndex} style={{ padding: '10px' }}>
                            {
                                col?.render ? col.render(row?.[col?.dataIndex] || "", row, index) : row?.[col.dataIndex] || ""
                            }
                        </TableCell>
                    );
                })}
            </React.Fragment>
            // </TableRow>
        );
    }, [columns]);
    const addImg = '/cuate.png'
    return (
        !filteredSymbols.length ? <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", cursor: "pointer", color: darkMode ? "white" : "black", fontSize: 14, fontWeight: 500, m: 0, height: "100%", }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", opacity: 0.4 }}>
                {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="100" fill={!darkMode ? "#000" : "#fff"}><path d="M346.5 240H272v-74.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-74.5c-8.8 0-16 6-16 16s7.5 16 16 16H240v74.5c0 9.5 7 16 16 16s16-7.2 16-16V272h74.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z"></path><path d="M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"></path></svg> */}
                <img alt='alldflsdg' src={addImg} style={{ width: "8rem" }} />
            </Box>
            <Box sx={{ mb: 1 , mt:'-2rem'}}>
                <span>{t('youHaveNoSelectedSymbols')}</span>
            </Box>
            <Button onClick={handleShowAllSymbols} variant="contained" size="small" startIcon={<AddIcon />} sx={{ fontWeight: 500, fontSize: 14, px: 2, }}>{t('Pleaseaddsymbols')}</Button>
        </Box> :
            <Paper style={{ height: `calc(100% - 48px)`, width: '100%', }}>
                <TableVirtuoso data={filteredSymbols} components={VirtuosoTableComponents} fixedHeaderContent={fixedHeaderContent} itemContent={Row} height={20} style={{ backgroundColor: darkMode ? "#151924" : "#fff", }}>
                </TableVirtuoso>
            </Paper>
    )
}

export default WatchlistTable